package org.hs_soft.runmynesto.domain.model.general

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextOverflow

data class TableColumn(
    val header: String,
    val key: String,
    val isNumeric: Boolean = false,
    val isSortable: Boolean = true,
    val overflow:Boolean=true,
    val sortFunction: ((Map<String, Any>) -> Comparable<*>)? = null,
    val width: Int? = null,
    val customContent: ((Map<String, Any?>) -> @Composable () -> Unit)? = null
)
